import React from 'react';

// Define the props interface for the PWAFooter component
interface PWAFooterProps {
  onTermsClick: () => void;     // Handler for Terms button click
  onPrivacyClick: () => void;   // Handler for Privacy button click
  onAboutClick: () => void;     // Handler for About button click
  className?: string;           // Optional className for additional styling
}

const PWAFooter: React.FC<PWAFooterProps> = ({
  onTermsClick,
  onPrivacyClick,
  onAboutClick,
  className = '',
}) => {
  return (
    <footer
      className={`
        mt-auto
        bg-gradient-to-t from-blue-600/90 to-transparent
        backdrop-blur-sm
        text-white/90
        py-3 px-6 
        standalone:hidden
        w-full
        fixed bottom-0 left-0
        ${className}
      `}
    >
      <div
        className={`
          max-w-7xl mx-auto
          flex flex-row justify-between items-center
          gap-3
          pb-[env(safe-area-inset-bottom)]
        `}
      >
        {/* Left side buttons */}
        <div className="flex gap-4 text-[13px]">
          <button
            onClick={onTermsClick}
            className="hover:text-white transition-colors"
          >
            Terms
          </button>
          <button
            onClick={onPrivacyClick}
            className="hover:text-white transition-colors"
          >
            Privacy
          </button>
          <button
            onClick={onAboutClick}
            className="hover:text-white transition-colors"
          >
            About
          </button>
        </div>

        {/* Right side copyright */}
        <div className="text-[11px] text-right opacity-50">
          © 2025 Angel
        </div>
      </div>
    </footer>
  );
};

export default PWAFooter;
